/**
 * MED-1116 — shared tones for the pre-session colored callouts (`BannerCallout`,
 * used by `AiBanner` + `PeerLeaderBanner`). Tints from the design tokens
 * (STYLE_GUIDE.md): medleyGreen #4A7C59, warningAmber #E9A23B, each at 12% as
 * the callout surface.
 *
 * Kept in a non-component module so `BannerCallout` stays component-only (the
 * `react-refresh/only-export-components` rule disallows exporting object
 * constants alongside a component).
 */
export interface BannerTone {
  /** Mantine theme color key — drives the icon chip + title shade + buttons. */
  color: 'medleyGreen' | 'warningAmber';
  /** Callout surface tint. */
  bg: string;
}

export const BANNER_GREEN: BannerTone = {
  color: 'medleyGreen',
  bg: 'rgba(74, 124, 89, 0.12)',
};

export const BANNER_AMBER: BannerTone = {
  color: 'warningAmber',
  bg: 'rgba(233, 162, 59, 0.12)',
};
